(function (algolia) {
  'use strict';
  algolia.translations = {
    searchTitle: 'Search result',
    search: 'Current search',
    allProducts: 'See all products ',
    matching: 'matching',
    sortBy: 'Sorted by',
    relevance: 'Relevance',
    outOf: 'out of',
    resultsFound: 'results found',
    oneResultFound: '1 result found',
    noResultFound: 'Sorry, no results found',
    addToCart: 'Add to cart',
    searchForProduct: 'Search for products',
    searchResults: 'Search results',
    searchButtonLabel: 'Search',
    liveFilterInstructions:
      'Results update automatically as you type. Press Tab to move to the results below, then use Tab to review each result and Enter to open it. Press Enter in this field to see all results.',
    selectedFilter: 'Selected filters',
    clearAll: 'Clear all',
    outOfStock: 'Out of stock',
    products: 'Products',
    collections: 'Collections',
    articles: 'Articles',
    pages: 'Pages',
    try: 'Try',
    clearFilters: 'clearing the filters',
    or: 'or',
    changeInput: 'changing your input',
    showLess: 'Show less',
    showMore: 'Show more',
  };

  algolia.translation_helpers = {
    no_result_for: function () {
      return 'Sorry, no results for';
    },
    in: function (processingTimeMS) {
      return 'in ' + processingTimeMS / 1000 + 's';
    },

    outOf: function (page, hitsPerPage, nbHits) {
      return (
        page * hitsPerPage +
        1 +
        '-' +
        Math.min((page + 1) * hitsPerPage, nbHits) +
        ' out of'
      );
    },

    by: function (text) {
      if (!text) return '';
      return ' by ' + text;
    },

    render_title: function (text, query, nbProducts) {
      if (text === 'Products' && query) {
        return `${text} matching "${query}" (${nbProducts})`;
      }
      return `Popular ${text}`;
    },
  };
})(window.algoliaShopify);
